/**
 * @module requestStatusStyles
 * @purpose Package-status icon/colour lookup for CollectionRequestsView's row header icon box; delegates to the canonical two-dimension status styles.
 * @depends collection-request-status.styles (components/collections/collection-request-status-badge/)
 * @dependedOnBy CollectionRequestsView
 *
 * @rules
 * - State: none -- thin re-export wrapper, kept as a stable import path for the case-collections-tab page
 * - Errors: n/a
 */

import type { ReactNode } from 'react'
import type { PackageStatus, ReturnStatus } from '../../../types/collection-requests'
import {
  packageStatusColourFor,
  packageStatusIconFor,
  returnStatusColourFor,
} from '../../../components/collections/collection-request-status-badge/collection-request-status.styles'

export function statusColourFor(status: PackageStatus): string {
  return packageStatusColourFor(status)
}

export function statusIconFor(status: PackageStatus): ReactNode {
  return packageStatusIconFor(status)
}

export function returnStatusColourForRequest(status: ReturnStatus): string | null {
  return returnStatusColourFor(status)
}
